import { Component, Input, OnInit, ElementRef, OnDestroy } from '@angular/core';
import { UserControlOption } from '../../services/header.service';
import { MeResponse } from '../../../app/models/profile/me-response.model';

@Component({
  standalone: false,
  selector: 'cm-user-controls',
  templateUrl: './user-controls.component.html',
  styleUrls: ['./user-controls.component.scss'],
})
export class UserControlsComponent implements OnInit, OnDestroy {
  @Input() user: MeResponse;

  @Input() userControls: UserControlOption[];

  expanded = false;

  private documentClickListener: (event: MouseEvent) => void;

  constructor(private elementRef: ElementRef) {}

  ngOnInit(): void {
    this.documentClickListener = (event: MouseEvent) => {
      const clickedInside = this.elementRef.nativeElement.contains(event.target);

      if (!clickedInside && this.expanded) {
        this.expanded = false;
      }
    };

    document.addEventListener('click', this.documentClickListener);
  }

  ngOnDestroy(): void {
    document.removeEventListener('click', this.documentClickListener);
  }

  closeMenu() {
    this.expanded = false;
  }
}
